import DSA_0_1_Knapsack from "./dsa_components/DSA_0_1_Knapsack";
import DSA_Arrays from "./dsa_components/DSA_Arrays";
import DSA_Array_Implementation from "./dsa_components/DSA_Array_Implementation";
import DSA_AVL_Trees from "./dsa_components/DSA_AVL_Trees";
import DSA_Bellman_Ford from "./dsa_components/DSA_Bellman_Ford";
import DSA_Binary_Search from "./dsa_components/DSA_Binary_Search";
import DSA_Binary_Search_Time from "./dsa_components/DSA_Binary_Search_Time";
import DSA_Binary_Trees from "./dsa_components/DSA_Binary_Trees";
import DSA_BST from "./dsa_components/DSA_BST";
import DSA_Bubble_Sort from "./dsa_components/DSA_Bubble_Sort";
import DSA_Bubble_Sort_Time from "./dsa_components/DSA_Bubble_Sort_Time";
import DSA_Certificate from "./dsa_components/DSA_Certificate";
import DSA_Counting_Sort from "./dsa_components/DSA_Counting_Sort";
import DSA_Counting_Sort_Time from "./dsa_components/DSA_Counting_Sort_Time";
import DSA_Cycle_Detection from "./dsa_components/DSA_Cycle_Detection";
import DSA_Dijkstra from "./dsa_components/DSA_Dijkstra";
import DSA_Dynamic_Programming from "./dsa_components/DSA_Dynamic_Programming";
import DSA_Edmonds_Karp from "./dsa_components/DSA_Edmonds_Karp";
import DSA_Euclidean_Algorithm from "./dsa_components/DSA_Euclidean_Algorithm";
import DSA_Examples from "./dsa_components/DSA_Examples";
import DSA_Exercises from "./dsa_components/DSA_Exercises";
import DSA_Ford_Fulkerson from "./dsa_components/DSA_Ford_Fulkerson";
import DSA_Graphs from "./dsa_components/DSA_Graphs";
import DSA_Graphs_Implementation from "./dsa_components/DSA_Graphs_Implementation";
import DSA_Graphs_Traversal from "./dsa_components/DSA_Graphs_Traversal";
import DSA_Greedy_Algorithms from "./dsa_components/DSA_Greedy_Algorithms";
import DSA_Hash_Maps from "./dsa_components/DSA_Hash_Maps";
import DSA_Hash_Sets from "./dsa_components/DSA_Hash_Sets";
import DSA_Hash_Tables from "./dsa_components/DSA_Hash_Tables";
import DSA_Home from "./dsa_components/DSA_Home";
import DSA_Huffman_Coding from "./dsa_components/DSA_Huffman_Coding";
import DSA_Inorder_Traversal from "./dsa_components/DSA_Inorder_Traversal";
import DSA_Insertion_Sort from "./dsa_components/DSA_Insertion_Sort";
import DSA_Insertion_Sort_Time from "./dsa_components/DSA_Insertion_Sort_Time";
import DSA_Intro from "./dsa_components/DSA_Intro";
import DSA_Kruskals from "./dsa_components/DSA_Kruskals";
import DSA_Linear_Search from "./dsa_components/DSA_Linear_Search";
import DSA_Linear_Search_Time from "./dsa_components/DSA_Linear_Search_Time";
import DSA_Linked_Lists from "./dsa_components/DSA_Linked_Lists";
import DSA_Linked_Lists_Memory from "./dsa_components/DSA_Linked_Lists_Memory";
import DSA_Linked_Lists_Operations from "./dsa_components/DSA_Linked_Lists_Operations";
import DSA_Linked_Lists_Types from "./dsa_components/DSA_Linked_Lists_Types";
import DSA_Maximum_Flow from "./dsa_components/DSA_Maximum_Flow";
import DSA_Memoization from "./dsa_components/DSA_Memoization";
import DSA_Merge_Sort from "./dsa_components/DSA_Merge_Sort";
import DSA_Merge_Sort_Time from "./dsa_components/DSA_Merge_Sort_Time";
import DSA_Minimum_Spanning_Tree from "./dsa_components/DSA_Minimum_Spanning_Tree";
import DSA_Postorder_Traversal from "./dsa_components/DSA_Postorder_Traversal";
import DSA_Preorder_Traversal from "./dsa_components/DSA_Preorder_Traversal";
import DSA_Prims from "./dsa_components/DSA_Prims";
import DSA_Queues from "./dsa_components/DSA_Queues";
import DSA_Quick_Sort from "./dsa_components/DSA_Quick_Sort";
import DSA_Quick_Sort_Time from "./dsa_components/DSA_Quick_Sort_Time";
import DSA_Quiz from "./dsa_components/DSA_Quiz";
import DSA_Radix_Sort from "./dsa_components/DSA_Radix_Sort";
import DSA_Radix_Sort_Time from "./dsa_components/DSA_Radix_Sort_Time";
import DSA_Selection_Sort from "./dsa_components/DSA_Selection_Sort";
import DSA_Selection_Sort_Time from "./dsa_components/DSA_Selection_Sort_Time";
import DSA_Shortest_Path from "./dsa_components/DSA_Shortest_Path";
import DSA_Simple_Algorithm from "./dsa_components/DSA_Simple_Algorithm";
import DSA_Stacks from "./dsa_components/DSA_Stacks";
import DSA_Study_Plan from "./dsa_components/DSA_Study_Plan";
import DSA_Syllabus from "./dsa_components/DSA_Syllabus";
import DSA_Tabulation from "./dsa_components/DSA_Tabulation";
import DSA_Time_Complexity_Intro from "./dsa_components/DSA_Time_Complexity_Intro";
import DSA_Traveling_Salesman from "./dsa_components/DSA_Traveling_Salesman";
import DSA_Trees from "./dsa_components/DSA_Trees";
import DSA_Tutorial from "./dsa_components/DSA_Tutorial";

const AllDSAComponents = {
  "<DSA_0_1_Knapsack />": DSA_0_1_Knapsack,
  "<DSA_Arrays />": DSA_Arrays,
  "<DSA_Array_Implementation />": DSA_Array_Implementation,
  "<DSA_AVL_Trees />": DSA_AVL_Trees,
  "<DSA_Bellman_Ford />": DSA_Bellman_Ford,
  "<DSA_Binary_Search />": DSA_Binary_Search,
  "<DSA_Binary_Search_Time />": DSA_Binary_Search_Time,
  "<DSA_Binary_Trees />": DSA_Binary_Trees,
  "<DSA_BST />": DSA_BST,
  "<DSA_Bubble_Sort />": DSA_Bubble_Sort,
  "<DSA_Bubble_Sort_Time />": DSA_Bubble_Sort_Time,
  "<DSA_Certificate />": DSA_Certificate,
  "<DSA_Counting_Sort />": DSA_Counting_Sort,
  "<DSA_Counting_Sort_Time />": DSA_Counting_Sort_Time,
  "<DSA_Cycle_Detection />": DSA_Cycle_Detection,
  "<DSA_Dijkstra />": DSA_Dijkstra,
  "<DSA_Dynamic_Programming />": DSA_Dynamic_Programming,
  "<DSA_Edmonds_Karp />": DSA_Edmonds_Karp,
  "<DSA_Euclidean_Algorithm />": DSA_Euclidean_Algorithm,
  "<DSA_Examples />": DSA_Examples,
  "<DSA_Exercises />": DSA_Exercises,
  "<DSA_Ford_Fulkerson />": DSA_Ford_Fulkerson,
  "<DSA_Graphs />": DSA_Graphs,
  "<DSA_Graphs_Implementation />": DSA_Graphs_Implementation,
  "<DSA_Graphs_Traversal />": DSA_Graphs_Traversal,
  "<DSA_Greedy_Algorithms />": DSA_Greedy_Algorithms,
  "<DSA_Hash_Maps />": DSA_Hash_Maps,
  "<DSA_Hash_Sets />": DSA_Hash_Sets,
  "<DSA_Hash_Tables />": DSA_Hash_Tables,
  "<DSA_Home />": DSA_Home,
  "<DSA_Huffman_Coding />": DSA_Huffman_Coding,
  "<DSA_Inorder_Traversal />": DSA_Inorder_Traversal,
  "<DSA_Insertion_Sort />": DSA_Insertion_Sort,
  "<DSA_Insertion_Sort_Time />": DSA_Insertion_Sort_Time,
  "<DSA_Intro />": DSA_Intro,
  "<DSA_Kruskals />": DSA_Kruskals,
  "<DSA_Linear_Search />": DSA_Linear_Search,
  "<DSA_Linear_Search_Time />": DSA_Linear_Search_Time,
  "<DSA_Linked_Lists />": DSA_Linked_Lists,
  "<DSA_Linked_Lists_Memory />": DSA_Linked_Lists_Memory,
  "<DSA_Linked_Lists_Operations />": DSA_Linked_Lists_Operations,
  "<DSA_Linked_Lists_Types />": DSA_Linked_Lists_Types,
  "<DSA_Maximum_Flow />": DSA_Maximum_Flow,
  "<DSA_Memoization />": DSA_Memoization,
  "<DSA_Merge_Sort />": DSA_Merge_Sort,
  "<DSA_Merge_Sort_Time />": DSA_Merge_Sort_Time,
  "<DSA_Minimum_Spanning_Tree />": DSA_Minimum_Spanning_Tree,
  "<DSA_Postorder_Traversal />": DSA_Postorder_Traversal,
  "<DSA_Preorder_Traversal />": DSA_Preorder_Traversal,
  "<DSA_Prims />": DSA_Prims,
  "<DSA_Queues />": DSA_Queues,
  "<DSA_Quick_Sort />": DSA_Quick_Sort,
  "<DSA_Quick_Sort_Time />": DSA_Quick_Sort_Time,
  "<DSA_Quiz />": DSA_Quiz,
  "<DSA_Radix_Sort />": DSA_Radix_Sort,
  "<DSA_Radix_Sort_Time />": DSA_Radix_Sort_Time,
  "<DSA_Selection_Sort />": DSA_Selection_Sort,
  "<DSA_Selection_Sort_Time />": DSA_Selection_Sort_Time,
  "<DSA_Shortest_Path />": DSA_Shortest_Path,
  "<DSA_Simple_Algorithm />": DSA_Simple_Algorithm,
  "<DSA_Stacks />": DSA_Stacks,
  "<DSA_Study_Plan />": DSA_Study_Plan,
  "<DSA_Syllabus />": DSA_Syllabus,
  "<DSA_Tabulation />": DSA_Tabulation,
  "<DSA_Time_Complexity_Intro />": DSA_Time_Complexity_Intro,
  "<DSA_Traveling_Salesman />": DSA_Traveling_Salesman,
  "<DSA_Trees />": DSA_Trees,
  "<DSA_Tutorial />": DSA_Tutorial,
};

export default AllDSAComponents;
